import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Page from "../../components/vapor/page";
import { saveOnboarding } from "../../actions/onboarding";
import OnboardingComponent from "../../components/onboarding";
import { RootState } from "../../reducers/store";
import { OnboardingSave } from "../../interfaces/onboarding";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    IconButton,
} from "@vapor/react-material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/pro-regular-svg-icons";
import { FormattedMessage } from "react-intl";
import { hideLockOverlay, showLockOverlay } from "../../actions/ui";

declare const window: any;

interface OnboardingViewProps {
    onComplete: () => void;
}

const OnboardingView = (props: OnboardingViewProps) => {
    const onboarding = useSelector((state: RootState) => state.onboarding);
    const [step, setStep] = useState(1);
    const [error, setError] = useState(false);
    const dispatch: any = useDispatch();

    const [bodyRequestCopy, setBodyRequestCopy] = useState({});

    const onSave = (bodyRequest: OnboardingSave | any) => {
        setBodyRequestCopy(bodyRequest);
        dispatch(showLockOverlay(true, "Salvataggio informazioni in corso..."));
        dispatch(
            saveOnboarding(
                bodyRequest,
                onboarding?.consent?.acceptGenericTerms,
            ),
        )
            .then((res: any) => {
                dispatch(hideLockOverlay());
                window?.aptrinsic?.(
                    "track",
                    "business-information:ONBOARDING-CONFIRM",
                );
                props.onComplete();
            })
            .catch((err: any) => {
                dispatch(hideLockOverlay());
                setError(true);
            });
    };

    return (
        <Page showMenu={false}>
            {error && (
                <Dialog
                    open={error}
                    onClose={() => setError(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle>
                        <FormattedMessage id="onboarding.errorTitle" />
                        <IconButton
                            color="primary"
                            onClick={() => setError(false)}
                        >
                            <FontAwesomeIcon icon={faClose} />
                        </IconButton>
                    </DialogTitle>
                    <Divider variant="fullWidth" />
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <FormattedMessage id="onboarding.errorDescription" />
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => setError(false)}
                            variant="outlined"
                        >
                            <FormattedMessage id="actions.close" />
                        </Button>
                        <Button
                            onClick={() => {
                                setError(false);
                                if (bodyRequestCopy) {
                                    onSave(bodyRequestCopy);
                                }
                            }}
                            variant="contained"
                        >
                            <FormattedMessage id="actions.retry" />
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
            <OnboardingComponent
                onSave={onSave}
                step={step}
                setStep={setStep}
            />
        </Page>
    );
};

export default OnboardingView;
